const base64 = bytes => btoa(String.fromCharCode(...new Uint8Array(bytes)));

/** Send setup inputs to the paired helper without saving readable passwords on the server. */
export default async function sealInput(publicKey, input, commandId) {
    const rsa = await crypto.subtle.importKey(
        'spki',
        Uint8Array.from(atob(publicKey), character => character.charCodeAt(0)),
        { name: 'RSA-OAEP', hash: 'SHA-256' },
        false,
        ['encrypt']
    );
    const key = await crypto.subtle.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt']);
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const content = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv, additionalData: new TextEncoder().encode(commandId) },
        key,
        new TextEncoder().encode(JSON.stringify(input))
    );
    const wrapped = await crypto.subtle.encrypt({ name: 'RSA-OAEP' }, rsa, await crypto.subtle.exportKey('raw', key));
    return { key: base64(wrapped), iv: base64(iv), content: base64(content) };
}
